"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MAlocalization = void 0;
const sprintf_js_1 = require("sprintf-js");
const MAlocalization = (project, key, version = '0.0.0') => __awaiter(void 0, void 0, void 0, function* () {
    const functionUrl = 'https://us-central1-malocalization-prod.cloudfunctions.net';
    const getLanguageBundle = (project, key, version) => __awaiter(void 0, void 0, void 0, function* () {
        const expire = new Date().getTime() + 60 * 4 * 1000;
        const hmac = yield createHmac(`getBundle-${project}-Web-${version}-production-${expire}`, key);
        const response = yield fetch(`${functionUrl}/getBundle?project=${project}&platform=Web&version=${version}&mode=production&expire=${expire}&hmac=${hmac}`, {
            method: 'GET',
        });
        let json = {};
        try {
            json = yield response.json();
        }
        catch (err) {
            return "Couldn't fetch language bundle. Check your keys";
        }
        let content = [{ isDefault: true, iso: 'en', items: [{ key: 'initial', value: 'initial' }] }];
        if (json.error)
            return json.error;
        if (json.url !== undefined)
            content = (yield (yield fetch(json.url, { method: 'get' })).json());
        return content;
    });
    const createHmac = (msg, secret) => __awaiter(void 0, void 0, void 0, function* () {
        var enc = new TextEncoder();
        const key = yield window.crypto.subtle.importKey("raw", enc.encode(secret), {
            name: "HMAC",
            hash: { name: "SHA-256" }
        }, false, ["sign", "verify"]);
        const signature = yield window.crypto.subtle.sign("HMAC", key, enc.encode(msg));
        return btoa(String.fromCharCode(...new Uint8Array(signature)));
    });
    const strings = yield getLanguageBundle(project, key, version);
    if (typeof strings === "string")
        return { error: strings };
    let curLang = 'en';
    let curStrings = {};
    strings.forEach((lang) => {
        if (lang.isDefault) {
            curLang = lang.iso;
            curStrings = (lang.items).reduce((acc, cur) => { acc[cur.key] = cur.value; return acc; }, {});
        }
    });
    return {
        translate: (key, vars = null) => {
            if (vars === null)
                return curStrings[key];
            if (Array.isArray(vars))
                return sprintf_js_1.sprintf(curStrings[key], ...vars);
            return sprintf_js_1.sprintf(curStrings[key], vars);
        },
        setLanguage: (sLang) => {
            let found = false;
            strings.forEach((lang) => {
                if (lang.iso === sLang) {
                    curLang = lang.iso;
                    curStrings = (lang.items).reduce((acc, cur) => { acc[cur.key] = cur.value; return acc; }, {});
                    found = true;
                }
            });
            return found;
        },
        getVue(locale) {
            var _a;
            const lang = strings.find((cand) => cand.iso === locale);
            if (lang === undefined)
                return {};
            return (_a = lang.items.reduce((acc, cur) => {
                acc[cur.key] = cur.value;
                return acc;
            }, {})) !== null && _a !== void 0 ? _a : {};
        },
        getAvailableLanguages() {
            return strings.map((item) => item.iso);
        }
    };
});
exports.MAlocalization = MAlocalization;
